import { handleApiCalls } from './axiosInstance';
import BaseAPI from './baseAPI';

class FAVRValuesAPI extends BaseAPI {
  constructor() {
    super({ suffix: 'favr-values' });
  }
  /**
   * Allow company/system admin to apply adjusted rate values
   * @param {string} companyId
   * @param {string[]} usersIds
   */
  async applyAdjustedRateValues(companyId, usersIds) {
    const result = await handleApiCalls('post', `${this.baseUrl}/adjustment`, {
      companyId,
      usersIds,
    });

    return result.data;
  }

  /**
   * Request new rate for a given period anomaly
   * @param {string} periodAnomalyId
   */
  async requestNewRate(periodAnomalyId) {
    await handleApiCalls('post', `${this.baseUrl}/request`, { periodAnomalyId });
  }

  /**
   * Fetches the inputs required to generate a FAVR rate.
   *
   * @param {object} params Rate input lookup parameters
   * @param {string} params.zip ZIP code used for location-based costs
   * @param {number} params.annualMiles Annual business mileage
   * @param {number} params.retentionYears Number of vehicle retention years
   * @param {string} params.standardVehicleId Standard vehicle ID
   * @returns {Promise<object>} Vehicle costs, fuel economy, and yearly cost data
   */
  async fetchRateInputs({ zip, annualMiles, retentionYears, standardVehicleId }) {
    const url = this.customBaseUrl('favr/rate-inputs');
    const response = await handleApiCalls('get', url, {
      params: { zip, annualMiles, retentionYears, standardVehicleId },
    });
    return response.data;
  }

  async generateFavrRate(params) {
    const response = await handleApiCalls('post', `${this.baseUrl}/calculate`, params);
    return response.data;
  }
}

export default FAVRValuesAPI;
